<template>
  <div :class="[{ purpose: this.data?.body?.purpose }]" style="width: 600px;">
    <q-form @submit="this.onSubmit" class="form-1c">
      <div class="form-1c__row">
        <label class="form-1c__label"
          >Дата завершения проекта <span class="required">*</span></label
        >
        <div class="form-1c__field">
          <CustomDate
            placeholder="Выберите дату"
            :required="true"
            @change_date="(value) => onChange('project_finish_date', value)"
            :value="this.formData.project_finish_date"
            :fullWidth="true"
          />
        </div>
      </div>
      <CustomModalFooter
        :btn-loading="this.loading"
        submitBtnText="Создать ДС"
      />
    </q-form>
  </div>
</template>
<script>

import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomDate from "@/components/form/CustomDate";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { useAppStore } from "@/services/store/app";
import { formatDate, parseDateDDMMYYYY } from "@/utils/formatDate";
import { createDS } from "@/views/ProjectsEntry/services";

function getInitialFinishDate(finishDateStr) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const parsed = parseDateDDMMYYYY(finishDateStr) || (finishDateStr ? new Date(finishDateStr) : null)
  const date = parsed && !isNaN(parsed.getTime()) ? parsed : today
  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  const value = dateOnly.getTime() < today.getTime() ? today : dateOnly
  return formatDate(value)
}

export default {
  name: "change-project-date",
  components: { CustomDate, CustomModalFooter },
  props: ['data'],
  data() {
    const initial = getInitialFinishDate(this.data?.body?.finish_date)
    return {
      loading: false,
      formData: {
        project_finish_date: initial || formatDate(new Date()),
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      const res = await createDS({...this.formData, project_id: this.data?.body?.project_id})
      this.loading = false
      if (!res) return
      if (this.data?.onSubmit)
        await this.data?.onSubmit()
      this.showSucceedSnackbar()
      this.closeModal()
      this.closeSecondaryModal()
    },
  },
  setup() {
    const { closeModal, closeSecondaryModal } = useAppStore()
    const { showSucceedSnackbar } = useCustomSnackbar()
    return { showSucceedSnackbar, closeModal, closeSecondaryModal }
  },
}
</script>

<style scoped lang="scss">
.form-1c {
  margin-top: 10px;

  &__row {
    margin-bottom: 10px;
  }

  &__label {
    margin-bottom: 5px;
    display: block;

    .required {
      color: red;
    }
  }

  &__field {
    flex: 1;
    min-width: 0;

    &--readonly {
      padding: 8px 10px;
      background-color: #f8f8f8;
      border: 1px solid #ddd;
      border-radius: 3px;
      font-size: 13px;
      color: #333;
    }

    &--placeholder {
      padding: 8px 10px;
      color: #999;
      font-size: 13px;
    }

    &--warning {
      padding: 8px 10px;
      background-color: #fff3cd;
      border: 1px solid #ffc107;
      border-radius: 3px;
      font-size: 12px;
      color: #856404;
    }

    &--sum {
      padding: 8px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #2e7d32;
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 20px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
}

@media (max-width: 600px) {
  .form-1c {
    &__grid {
      grid-template-columns: 1fr;
    }

    &__row {
      flex-direction: column;
    }

    &__label {
      width: 100%;
      text-align: left;
      padding-top: 0;
      margin-bottom: 4px;
    }
  }
}
</style>
